export const blockIconsTransportationSailingNew = (
	<span className='material-symbols-outlined'>sailing</span>
);
